import { ClassFlag } from "../../../dom-tools/ClassFlag";
import { ElementAttribute } from "../../../dom-tools/ElementAttribute";
import { HTMLEditor } from "../../../dom-tools/HTMLEditor";

export abstract class Sorter
{
  static readonly setting    = new ElementAttribute( "-sorter--setting" );
  static readonly sorterType = new ElementAttribute( "-sorter--type" );
  static readonly selector   = new ElementAttribute( "-selector" );
  static readonly reverse    = new ElementAttribute( "-reverse" );
  static readonly firstVisible = new ClassFlag( "first-visible" );

  protected abstract _sortElements( elements:Element[] ):void;
  sorterSettings:Element;
  selector:string;
  reverse = false;

  constructor( sorterSettings:Element, reverse:boolean = false )
  {
    this.sorterSettings = sorterSettings;
    this.selector = Sorter.selector.from( sorterSettings );

    this.reverse = reverse;
  }

  sortElements( elements:Element[] )
  {
    if ( elements.length == 0 )
    {
      return;
    }

    let before = [].concat( elements );

    this._sortElements( elements );

    //let parent = elements[ 0 ].parentElement;
    let parents = new Map<Element,Element>();

    elements.forEach( e => { parents.set( e, e.parentElement ); HTMLEditor.remove( e ) } );

    
    if ( this.reverse )
    {
      elements.reverse();
    }

    elements.forEach( e => Sorter.firstVisible.setAs( e, false ) );

    if ( elements.length > 0 )
    {
      Sorter.firstVisible.set( elements[ 0 ] );
    }
    
    
    elements.forEach( e => parents.get( e ).appendChild( e ) );

  }

}